// ==========================================================================
// Console wrapper
// ==========================================================================

const noop = () => {};

export default class Console {
    constructor(enabled = false) {
        this.enabled = window.console && enabled;

        if (this.enabled) {
            this.log('Debugging enabled');
        }
    }

    log(...any) {
        if (this.enabled) {
            // eslint-disable-next-line no-console
            console.log(...this.format('debug', any));
        }
    }

    warn(...any) {
        if (this.enabled) {
            // eslint-disable-next-line no-console
            console.warn(...this.format('warn', any));
        }
    }

    error(...any) {
        if (this.enabled) {
            // eslint-disable-next-line no-console
            console.error(...this.format('error', any));
        }
    }

    // eslint-disable-next-line class-methods-use-this
    format(level, any) {
        return [`${(new Date()).toISOString()} Player [${level.toUpperCase()}]:`, ...any];
    }
}
